export const SHOW_FULLSCREEN_LOADER = 'SHOW_FULLSCREEN_LOADER';
export const HIDE_FULLSCREEN_LOADER = 'HIDE_FULLSCREEN_LOADER';
